export type ShotResult = (typeof ShotResult)[keyof typeof ShotResult];

export const ShotResult = {
  UNKNOWN: 'UNKNOWN',
  MAKE: 'MAKE',
  MISS: 'MISS',
} as const;

export function isShotResult(arg: unknown): arg is ShotResult {
  return Object.values(ShotResult).includes(arg as ShotResult);
}

export function isShotResultArray(arg: unknown): arg is ShotResult[] {
  return Array.isArray(arg) && arg.every(isShotResult);
}
